export const fileNames = [
  {
    image: "making_art_759c.svg",
    title: "Making art",
    tags: "creative, painting, woman, art",
  },
  {
    image: "quitting_time_dm8t.svg",
    title: "Quitting time",
    tags: "work, office, break, man, coffee, employee",
  },
  {
    image: "user_flow_vr6w.svg",
    title: "User flow",
    tags: "wireframes, prototyping, design, ui, ux, invision, designer, personas, mockups, research, draw, low fidelity",
  },
  {
    image: "printing_invoices_5r4r.svg",
    title: "Printing invoices",
    tags: "receipt, form, copy machine, pay, money, earn, finance",
  },
  {
    image: "schedule_pnbk.svg",
    title: "Schedule",
    tags: "calendar, woman, character, organize, events",
  },
  {
    image: "in_progress_ql66.svg",
    title: "In progress",
    tags: "development, creation, process, cogwheel, woman",
  },
  {
    image: "messaging_fun_86y2.svg",
    title: "Messaging fun",
    tags: "message, connect, character, communicate, sent, woman",
  },
  {
    image: "mobile_testing_reah.svg",
    title: "Mobile testing",
    tags: "smartphone, iphone",
  },
  {
    image: "barber_3uel.svg",
    title: "Barber",
    tags: "haircut, groom, looks, beauty",
  },
  {
    image: "version_control_9bpv.svg",
    title: "Version control",
    tags: "git, github, bitbucket, gitlab, versioning, continuous integration, merge, commit, push, code, programming, source, development",
  },
  {
    image: "status_update_jjgk.svg",
    title: "Status update",
    tags: "browser, social, site, communication, chat, message, talk",
  },
  {
    image: "jason_mask_t07o.svg",
    title: "Jason mask",
    tags: "friday 13th, halloween, serial killer, mask, jason",
  },
  {
    image: "social_dashboard_k3pt.svg",
    title: "Social dashboard",
    tags: "media, smartphone, mobile, facebook, twitter, instagram, youtube, twitch, pinterest",
  },
  {
    image: "robotics_kep0.svg",
    title: "Robotics",
    tags: "machine learning, artificial, intelligence, singularity, smart, android, humanoid, lab",
  },
  {
    image: "scrum_board_cesn.svg",
    title: "Scrum board",
    tags: "kanban, board, brainstorming, project, planning, stages, mindmap, study, students",
  },
  {
    image: "usability_testing_2xs4.svg",
    title: "Usability testing",
    tags: "design, browser, interaction design, use, system, men, product, website, interface, prototype",
  },
  {
    image: "wind_turbine_x2k4.svg",
    title: "Wind turbine",
    tags: "energy, clean, battery charging, wind farms, renewable energy, kinetic energy, woman",
  },
  {
    image: "developer_activity_bv83.svg",
    title: "Developer activity",
    tags: "programmer, man, laptop, github, repo, stats, contributors, tracking, charts",
  },
  {
    image: "medicine_b1ol.svg",
    title: "Medicine",
    tags: "doctors, hospital, clinic, man, woman, examination, appointment, physician, medical practitioner",
  },
  {
    image: "revenue_3osh.svg",
    title: "Revenue",
    tags: "laptop, man, money, economics, business, investment, banking, accounting, income, stock, funds",
  },
  {
    image: "scooter_aia8.svg",
    title: "Scooter",
    tags: "man, san francisco, ride, character, mobility, clean energy, bike, tech, transportation, battery",
  },
  {
    image: "wallet_aym5.svg",
    title: "Wallet",
    tags: "money, bank, man, pig, income, pay, earn, personal finance, fund, investment, deposit, character",
  },
  {
    image: "witch_7uk7.svg",
    title: "Witch",
    tags: "halloween, scary, pumpkin, woman, character",
  },
  {
    image: "wedding_t1yl.svg",
    title: "Wedding",
    tags: "bride, groom, married, happy, love, forever, celebration, man, woman, wife, husband, family",
  },
  {
    image: "warning_cyit.svg",
    title: "Warning",
    tags: "404 page, alert, notice, rocks, be careful, signal, woman, character, important",
  },
  {
    image: "personal_trainer_ote3.svg",
    title: "Personal trainer",
    tags: "woman, girl, gym, workout, health, relax, character, exercise, physical strength, flexibility, man",
  },
  {
    image: "winners_2yls.svg",
    title: "Winners",
    tags: "congrats, special moment, celebration, happy, achievement, success, people, characters",
  },
  {
    image: "group_chat_v059.svg",
    title: "Group chat",
    tags: "communication, message, talk, sms, instant, messaging, response, inbox, sent, chatbot, speak, language, people",
  },
  {
    image: "night_calls_5jh7.svg",
    title: "Night calls",
    tags: "dark, woman, calling, working, character, phone, speaking, talking",
  },
  {
    image: "mobile_marketing_iqbr.svg",
    title: "Mobile marketing",
    tags: "cell phone, people, characters, digital strategy, reaching users, audience, device, smartphone",
  },
  {
    image: "winter_designer_a2m7.svg",
    title: "Winter designer",
    tags: "woman, office, desk, design, pc, create, prototype, ui, ux, interface, hannah",
  },
  {
    image: "maker_launch_crhe.svg",
    title: "Maker launch",
    tags: "rocket, fast, space, man, push button, project",
  },
  {
    image: "data_trends_b0wg.svg",
    title: "Data trends",
    tags: "charts, tabs, metrics, numbers, excel, analytics, graphics, infographics, pie, bars, segmentation, polls, analytics, statistics",
  },
  {
    image: "features_overview_jg7a.svg",
    title: "Features overview",
    tags: "site, install, woman, characters, design, template, structure, guide, course, complete",
  },
  {
    image: "interview_rmcf.svg",
    title: "Interview",
    tags: "man, woman, job, resume, talking, work, deal, characters",
  },
  {
    image: "content_vbqo.svg",
    title: "Content",
    tags: "browser, news, man, people, blog, characters, create, information",
  },
  {
    image: "questions_75e0.svg",
    title: "Questions",
    tags: "quiz, ask, answer, woman, character, faq, problem",
  },
  {
    image: "balloons_vxx5.svg",
    title: "Balloons",
    tags: "woman, celebration, happy, congrats, welcome, character, air, wind",
  },
  {
    image: "doctors_hwty.svg",
    title: "Doctors",
    tags: "hospital, woman, man, examination, appointment, physician, medical practitioner",
  },
  {
    image: "savings_hjfl.svg",
    title: "Savings",
    tags: "money, bank, man, pig, income, pay, earn, personal finance, fund, investment, deposit, character",
  },
  {
    image: "children_4rtb.svg",
    title: "Children",
    tags: "friends, happy, jump rope, playful, siblings, young, characters",
  },
  {
    image: "security_o890.svg",
    title: "Security",
    tags: "safety, browser, lock, man, bodyguard, character, private",
  },
  {
    image: "super_thank_you_obwk.svg",
    title: "Super thank you",
    tags: "love, appreciation, woman, happy, in love, character, congratulation, welcome, new user, first time",
  },
  {
    image: "voice_control_ofo1.svg",
    title: "Voice control",
    tags: "man, office, echo, working, character, alexa, speech recognition, virtual assistant",
  },
  {
    image: "missed_chances_k3cq.svg",
    title: "Missed chances",
    tags: "man, woman, people, characters, city, lost opportunity",
  },
  {
    image: "world_9iqb.svg",
    title: "World",
    tags: "earth, destination, pins, man, characters, trip, pc, mac",
  },
  {
    image: "setup_analytics_8qkl.svg",
    title: "Setup analytics",
    tags: "charts, metrics, numbers, graphics, infographics, polls, analytics, browser, man, character, install",
  },
  {
    image: "videographer_nnc7.svg",
    title: "Videographer",
    tags: "man, character, video, record, production, youtube, news broadcasting, camera operator, camera setup, filmmaking",
  },
  {
    image: "setup_wizard_r6mr.svg",
    title: "Setup wizard",
    tags: "guide, software, woman, character, options, fill, install, browser, multipage, information, gather, collect",
  },
  {
    image: "heartbroken_cble.svg",
    title: "Heartbroken",
    tags: "woman, character, nature, heart, sad, thinking, creative",
  },
  {
    image: "interaction_design_odgc.svg",
    title: "Interaction design",
    tags: "users, ux, ui, people, alexa, devices, woman, man, characters, pc, mobile, cell phone, interface",
  },
  {
    image: "startled_8p0r.svg",
    title: "Startled",
    tags: "monster, man, surprised, scary, character, 404",
  },
  {
    image: "site_stats_l57q.svg",
    title: "Site stats",
    tags: "charts, metrics, numbers, graphics, infographics, polls, analytics, pc, man, character, fast, speed, hourglass, time",
  },
  {
    image: "add_to_cart_vkjp.svg",
    title: "Add to cart",
    tags: "buy, pick, choose, woman, character, browser, online shopping",
  },
  {
    image: "confirmation_2uy0.svg",
    title: "Confirmation",
    tags: "check, people, man, woman, characters, accept, success, ready, order confirmed, congrats",
  },
  {
    image: "fatherhood_7i19.svg",
    title: "Fatherhood",
    tags: "dad, son, child, characters, family, parenthood, helping, skate, hallie",
  },
  {
    image: "dashboard_nklg.svg",
    title: "Dashboard",
    tags: "control, settings, preferences, users, data, analytics, stats, man, character, pc, mac",
  },
  {
    image: "feeling_blue_4b7q.svg",
    title: "Feeling blue",
    tags: "sad, woman, emoticon, character, 404",
  },
  {
    image: "order_confirmed_1m3v.svg",
    title: "Order confirmed",
    tags: "woman, character, success, cell phone, mobile, check, congrats",
  },
  {
    image: "business_plan_5i9d.svg",
    title: "Business plan",
    tags: "man, work, analytics, data, meeting, presentation, character, metrics, numbers, excel, statistics, graphics, infographics",
  },
  {
    image: "before_dawn_bqrj.svg",
    title: "Before dawn",
    tags: "woman, alone, nature, character, tree, bench, park, no electricity",
  },
  {
    image: "businesswoman_pc12.svg",
    title: "Businesswoman",
    tags: "character, work, walking, travel, busy, mobile, cell phone, person, networking",
  },
  {
    image: "getting_coffee_wntr.svg",
    title: "Getting coffee",
    tags: "man, woman, together, happy, conversation, talking, characters, outside",
  },
  {
    image: "pedestrian_crossing_l6jv.svg",
    title: "Pedestrian crossing",
    tags: "man, walking, road, character, crosswalk",
  },
  {
    image: "powerful_26ry.svg",
    title: "Powerful",
    tags: "strong, woman, businesswoman, chair, character, influence, welcome",
  },
  {
    image: "programming_2svr.svg",
    title: "Programming",
    tags: "programmer, pc, working, character, man, focus, coding, computer, working, testing, debugging, software development, building systems",
  },
  {
    image: "working_late_pukg.svg",
    title: "Working late",
    tags: "woman, laptop, sitting, work, office, night, city, view, character",
  },
  {
    image: "envelope_n8lc.svg",
    title: "Envelope",
    tags: "mail, open, chose, select, read, envelope, inbox, received, accepted, messages, man, character",
  },
  {
    image: "press_play_bx2d.svg",
    title: "Press play",
    tags: "tablet, apple, play, enter, watch, office, desk, woman, character, work, relax, login, sign up",
  },
  {
    image: "emails_6uqr.svg",
    title: "Emails",
    tags: "tablet, apple, mail, open, chose, select, read, envelope, inbox, received, accepted, messages",
  },
  {
    image: "dark_alley_hl3o.svg",
    title: "Dark alley",
    tags: "fire, winter, road, alone, walking, cold, shadow, woman, character, wall",
  },
  {
    image: "chef_lbjx.svg",
    title: "Chef",
    tags: "cook, man, character, kitchen, restaurant, hotel, food, recipe",
  },
  {
    image: "off_road_9oae.svg",
    title: "Off road",
    tags: "car, vehicle, people, characters, trip, nature, relax, happy",
  },
  {
    image: "QA_engineers_dg5p.svg",
    title: "QA engineers",
    tags: "work, man, character, quality assurance, feedback, detailed, test, estimating, errors, debugging",
  },
  {
    image: "pie_chart_6efe.svg",
    title: "Pie chart",
    tags: "charts, tabs, metrics, numbers, excel, analytics, statistics, graphics, infographics, pie, bars, segmentation, polls, man, character",
  },
  {
    image: "baby_ja7a.svg",
    title: "Baby",
    tags: "mother, child, maternity, love, family, mom, character, baby crib",
  },
  {
    image: "mobile_payments_edgf.svg",
    title: "Mobile payments",
    tags: "money, transfer, services, financial, device, phone, smartphone, cell phone, man, character, cash register",
  },
  {
    image: "design_community_rcft.svg",
    title: "Design community",
    tags: "dribbble, behance, designer news, prototypr, man, woman, characters, people, ui, ux, startups, tech",
  },
  {
    image: "preferences_uuo2.svg",
    title: "Preferences",
    tags: "settings, choose, like, woman, character, browser, customer",
  },
  {
    image: "businessman_97x4.svg",
    title: "Businessman",
    tags: "man, working, walking, busy, mobile, cell phone, person, character",
  },
  {
    image: "trip_dv9f.svg",
    title: "Trip",
    tags: "man, woman, vacation, characters, nature, map, photography, laptop, bag, couple, relax, laptop",
  },
  {
    image: "on_the_office_fbfs.svg",
    title: "On the office",
    tags: "office, work, code, relax, design, mac, apple, pc, desk, man, character, waiting",
  },
  {
    image: "wireframing_nxyi.svg",
    title: "Wireframing",
    tags: "design. woman, character, pc, mac, apple, ux. ui, web, browser, product, prototype, layout, template, interface",
  },
  {
    image: "product_teardown_elol.svg",
    title: "Product teardown",
    tags: "disassembling, man, phone, mobile, cell phone, man, character, device, identify, component parts, system functionality. information",
  },
  {
    image: "alien_science_nonm.svg",
    title: "Alien science",
    tags: "scientist, woman, lab, research, character, chemist, experiment, intelligent",
  },
  {
    image: "hang_out_h9ud.svg",
    title: "Hang out",
    tags: "coffee, break, people, man, woman, character, nature, friends, friendship, together, talking",
  },
  {
    image: "science_fqhl.svg",
    title: "Science",
    tags: "scientist, woman, lab, research, character, chemist, experiment",
  },
  {
    image: "conversation_h12g.svg",
    title: "Conversation",
    tags: "meeting, talk, friends, discussion, gossip, dialogue, man, characters",
  },
  {
    image: "business_deal_cpi9.svg",
    title: "Business deal",
    tags: "man, buy, sell, trade, characters, office, work, handshake, agreement",
  },
  {
    image: "focus_sey6.svg",
    title: "Focus",
    tags: "photography, artist, photos, photographer, nature, woman character, camera, shot, snap, snapshot, amber",
  },
  {
    image: "designer_life_w96d.svg",
    title: "Designer life",
    tags: "woman, office, work, design, prototype, pc, laptop, mac, character, ui, ux, users, interface, experience, collaboration, template, working, creative, chief",
  },
  {
    image: "server_status_5pbv.svg",
    title: "Server status",
    tags: "data, cloud, woman, character, check, online",
  },
  {
    image: "studying_s3l7.svg",
    title: "Studying",
    tags: "read, learn, school, homework, author, think, create, woman, character, work, book, analysis",
  },
  {
    image: "blank_canvas_3rbb.svg",
    title: "Blank canvas",
    tags: "empty, woman, drawing, painter, character, school, 404, not found, error",
  },
  {
    image: "smiley_face_lmgm.svg",
    title: "Smiley face",
    tags: "man, woman, people, happy, together, hug, characters, emoticons, feeling",
  },
  {
    image: "back_to_school_inwc.svg",
    title: "Back to school",
    tags: "family, mother, mom, boy, son, school, characters, teach",
  },
  {
    image: "product_tour_foyt.svg",
    title: "Product Tour",
    tags: "navigate, man, woman, people, characters, company, read, visitors, customer, news",
  },
  {
    image: "upload_87y9.svg",
    title: "Upload",
    tags: "man, files, style guide, characters, organize, documents, gathering, cloud",
  },
  {
    image: "fall_is_coming_dg3x.svg",
    title: "Fall is coming",
    tags: "park, day, people, man, woman, character, relax, walk, nature, bench, trees, life, happy",
  },
  {
    image: "target_kriv.svg",
    title: "Target",
    tags: "dart, man, character, goals, dart board, sport, hobby",
  },
  {
    image: "to_do_list_a49b.svg",
    title: "To do list",
    tags: "checklist, files, write, check, arrange, woman, character",
  },
  {
    image: "city_driver_jh2h.svg",
    title: "City driver",
    tags: "car, woman, travel, road, vehicle, character, mini cooper",
  },
  {
    image: "motherhood_7htu.svg",
    title: "Motherhood",
    tags: "maternity, love, child, family, mother, mom, character",
  },
  {
    image: "digital_nomad_9kgl.svg",
    title: "Digital nomad",
    tags: "remote, work, man, freelancer, character",
  },
  {
    image: "creativity_wqmm.svg",
    title: "Creativity",
    tags: "woman, browser, paint, color, design, prototype, palette, interface, character",
  },
  {
    image: "online_shopping_ga73.svg",
    title: "Online shopping",
    tags: "buy, clothes, pick, choose, woman, character, browser, smartphone, mobile, cell phone",
  },
  {
    image: "more_music_w70e.svg",
    title: "More music",
    tags: "man, woman, songs, piano, sing, together, diplo, characters, compose music, mo",
  },
  {
    image: "instant_support_elxh.svg",
    title: "Instant support",
    tags: "man, flying, character, sky, instantly, real time, work, teacher, radar, question, search, hero",
  },
  {
    image: "book_lover_mkck.svg",
    title: "Book lover",
    tags: "woman, reading, reads, character, self improve, hobby, author, writer, homework, study, school",
  },
  {
    image: "startup_life_2du2.svg",
    title: "Startup life",
    tags: "man, laptop, macbook, apple, programmer, designer, walking, character, startup",
  },
  {
    image: "design_tools_42tf.svg",
    title: "Design tools",
    tags: "ui, ux, users, interface, experience, prototype, sketch, adobe, xd, collaboration, template, characters, working, creative, office, computers, laptop",
  },
  {
    image: "mobile_browsers_lib5.svg",
    title: "Mobile browsers",
    tags: "edge, chrome, safari, people, woman, characters, phone, smartphone, browsers, internet, walking",
  },
  {
    image: "work_chat_erdt.svg",
    title: "Work chat",
    tags: "communication, message, talk, sms, instant, messaging, response, inbox, sent, chatbot, speak, language, group chat",
  },
  {
    image: "doctor_kw5l.svg",
    title: "Doctor",
    tags: "pediatrician, kid, characters, man, people, examination, doctor appointment, physician, medical practitioner",
  },
  {
    image: "team_spirit_hrr4.svg",
    title: "Team spirit",
    tags: "team, about us, work together, dog, characters, people, man, woman, members, voters, supporters, followers",
  },
  {
    image: "work_time_lhoj.svg",
    title: "Work time",
    tags: "working, office, man, character, pc, desk, chair, work, anges244",
  },
  {
    image: "empty_xct9.svg",
    title: "Empty",
    tags: "no data, empty state, man, character, box, carrying, not found, nothing, void",
  },
  {
    image: "weather_d9t2.svg",
    title: "Weather",
    tags: "forecast, man, character, predict weather, sun, clouds",
  },
  {
    image: "word_of_mouth_v1j9.svg",
    title: "Word of mouth",
    tags: "marketing, advertising, viral, man, woman, characters, whispering, strategies",
  },
  {
    image: "on_the_way_ldaq.svg",
    title: "On the way",
    tags: "delivering, vespa, packages, woman, character",
  },
  {
    image: "birthday_cake_7df8.svg",
    title: "Birthday cake",
    tags: "man, woman, celebration, birthday, cake, characters, people, balloons, happy, new",
  },
  {
    image: "a_day_at_the_park_owg1.svg",
    title: "A day at the park",
    tags: "people, man, woman, park, day, nature, walking, life, characters",
  },
  {
    image: "Calculator_0evy.svg",
    title: "Calculator",
    tags: "numbers, man, character, accountant, finance, number cruncher, data processor, statistician",
  },
  {
    image: "group_selfie_ijc6.svg",
    title: "Group selfie",
    tags: "man, woman, people, characters, photo, smartphone, take a selfie, selfie, photograph, happy, fun",
  },
  {
    image: "personalization_triu.svg",
    title: "Personalization",
    tags: "man, smartphone, iphone, mobile, character, customization",
  },
  {
    image: "relaxing_at_home_9tyc.svg",
    title: "Relaxing at home",
    tags: "sofa, couch, woman, laptop, home, relax, comfortable, character",
  },
  {
    image: "pilates_gpdb.svg",
    title: "Pilates",
    tags: "woman, girl, gym, workout, health, relax, character, exercise, physical strength, flexibility",
  },
  {
    image: "loading_frh4.svg",
    title: "Loading",
    tags: "woman, dog, loading, waiting, character",
  },
  {
    image: "running_wild_ni0y.svg",
    title: "Running wild",
    tags: "man, woman, run, freedom, happiness, joy, happy, characters, people",
  },
  {
    image: "taking_notes_tjaf.svg",
    title: "Taking notes",
    tags: "remember, man, notes, sticky notes, character, reading, think",
  },
  {
    image: "collection_u2np.svg",
    title: "Collection",
    tags: "photos, upload, man, character, browser, online, cloud, gathering",
  },
  {
    image: "thoughts_e49y.svg",
    title: "Thoughts",
    tags: "woman, park, nature, thinking, gaze, bench, alone, character, stare",
  },
  {
    image: "refreshing_ncum.svg",
    title: "Refreshing",
    tags: "soda, drink, people, man, woman, refresh, characters",
  },
  {
    image: "moment_to_remember_02gj.svg",
    title: "Moment to remember",
    tags: "selfie, man, character, mobile, smartphone, photo, taking photo, cellphone",
  },
  {
    image: "analysis_4jis.svg",
    title: "Analysis",
    tags: "man, woman, examination, detailed examination, study, working, characters",
  },
  {
    image: "workout_gcgu.svg",
    title: "Workout",
    tags: "exercise, woman, dance, character, healthy, happy",
  },
  {
    image: "airport_2581.svg",
    title: "Airport",
    tags: "man, travel, trip, airplane, coffee, businessman, character",
  },
  {
    image: "photocopy_gj0t.svg",
    title: "Photocopy",
    tags: "woman, papers, copy, character, photocopy machine, work, office",
  },
  {
    image: "campfire_s6y4.svg",
    title: "Campfire",
    tags: "girls, woman, forest, camping, relax, travel, characters, nature",
  },
  {
    image: "High_five_u364.svg",
    title: "High five",
    tags: "man, woman, couple, happy, successful, characters",
  },
  {
    image: "young_and_happy_hfpe.svg",
    title: "Young and happy",
    tags: "youthful, man, boy, character, joy, cheerful",
  },
  {
    image: "report_mx0a.svg",
    title: "Report",
    tags: "outline, detail, man, character, ipad, apple, analytics, data, announce, review, record, charts, tabs, metrics, numbers, excel, graphics, infographics, bars, polls",
  },
  {
    image: "music_r1se.svg",
    title: "Music",
    tags: "woman, dance, dancing, happy, samsung, mobile, cellphone, android, device, play, listen, smartphones, google, character",
  },
  {
    image: "navigation_lytx.svg",
    title: "Navigation",
    tags: "place, location, woman, character",
  },
  {
    image: "surfer_m6jb.svg",
    title: "Surfer",
    tags: "man, sea, beach, summer, character, surfing",
  },
  {
    image: "exploring_1l7f.svg",
    title: "Exploring",
    tags: "forest, woman, backpack, travel, seek, character",
  },
  {
    image: "onboarding_o8mv.svg",
    title: "Onboarding",
    tags: "man, character, site, website, browser, help, explain",
  },
  {
    image: "art_lover_yjfr.svg",
    title: "Art lover",
    tags: "woman, girl, painting, art, admire, character",
  },
  {
    image: "in_the_pool_c5h0.svg",
    title: "In the pool",
    tags: "woman, pool, sea, relax, character, summer",
  },
  {
    image: "successful_purchase_uyin.svg",
    title: "Successful purchase",
    tags: "shopping, bags, woman, buy, character, shopping therapy, purchase, success",
  },
  {
    image: "organize_resume_utk5.svg",
    title: "Organize resume",
    tags: "browser, woman, site, personal website, easy, resume, job, apply, characters",
  },
  {
    image: "android_jr64.svg",
    title: "Android",
    tags: "phone, cellphone, mobile, operating system, google, smartphones, google play, device",
  },
  {
    image: "ethereum_desire_wy1b.svg",
    title: "Ether",
    tags: "crypto, coin, cash, coinbase, blockchain, banks, money, women, plants, character",
  },
  {
    image: "reading_list_4boi.svg",
    title: "Reading list",
    tags: "man, books, read, recommendation, character, self improve",
  },
  {
    image: "gardening_j8jx.svg",
    title: "Gardening",
    tags: "woman, flowers, character, growing, landscaping, planting",
  },
  {
    image: "online_world_mc1t.svg",
    title: "Online world",
    tags: "woman, mobile, cellphone, message, connect, character, communicate",
  },
  {
    image: "messaging_uok8.svg",
    title: "Messaging",
    tags: "woman, mobile, cellphone, message, connect, character, communicate",
  },
  {
    image: "online_1qud.svg",
    title: "Online",
    tags: "instagram, twitter, facebook, twitch, youtube, linkedin, social, mobile, cellphone, man, books",
  },
  {
    image: "forgot_password_gi2d.svg",
    title: "Forgot password",
    tags: "man, password, login, sign in, character",
  },
  {
    image: "lost_bqr2.svg",
    title: "Lost",
    tags: "man, map, directions, gps, character, place, find",
  },
  {
    image: "beach_56sf.svg",
    title: "Beach",
    tags: "sun, summer, couple, man, woman, umbrella, ball, sand",
  },
  {
    image: "credit_card_payment_12va.svg",
    title: "Credit card payments",
    tags: "money, woman, pay, character, card, plastic money",
  },
  {
    image: "time_management_30iu.svg",
    title: "Time management",
    tags: "clock, woman, hour, schedule, busy, character, time control, arrangement of working time, timing",
  },
  {
    image: "inbox_cleanup_w2ur.svg",
    title: "Inbox cleanup",
    tags: "gmail, mail. email, yahoo mail, cleaner, clean, man, character",
  },
  {
    image: "crypto_flowers_6bgv.svg",
    title: "Crypto flowers",
    tags: "crypto, coin, cash, coinbase, blockchain, satoshi, banks, money, woman, plants, character",
  },
  {
    image: "community_8nwl.svg",
    title: "Community",
    tags: "man, woman, group, together, people, common, characters",
  },
  {
    image: "wall_post_83ul.svg",
    title: "Wall post",
    tags: "post, website, personal, browser, woman, man, comment, profile, write",
  },
  {
    image: "app_installation_mbdv.svg",
    title: "App installation",
    tags: "tablet, man, apps, android, app store, apple, install, character",
  },
  {
    image: "vr_chat_kq3p.svg",
    title: "VR chat",
    tags: "man, woman, laptop, chat, communication, character",
  },
  {
    image: "forever_5ag7.svg",
    title: "Forever",
    tags: "couple, sunset, man, woman, romantic, character, love, happy",
  },
  {
    image: "track_and_field_33qn.svg",
    title: "Track and field",
    tags: "sports, hobby, health, woman, character, obstacles, jump",
  },
  {
    image: "fishing_hoxa.svg",
    title: "Fishing",
    tags: "man, boat, sea, river, mountains, character, nature, hobby",
  },
  {
    image: "be_the_hero_ssr2.svg",
    title: "Be the hero",
    tags: "man, excalibur, sword, character, strength",
  },
  {
    image: "accept_terms_4in8.svg",
    title: "Accept terms",
    tags: "gdpr, privacy, terms, security, eu, ads, rules, websites",
  },
  {
    image: "gdpr_3xfb.svg",
    title: "GDPR",
    tags: "woman, gdpr, privacy, terms, security, eu, ads, rules, websites, character, flag",
  },
  {
    image: "in_sync_xwsa.svg",
    title: "In sync",
    tags: "devices, people, woman, man, characters, mobile, cell phone, tablet, laptop, synchronize",
  },
  {
    image: "basketball_agx4.svg",
    title: "Basketball",
    tags: "player, ball, man, sport, character",
  },
  {
    image: "social_ideas_e8rj.svg",
    title: "Social ideas",
    tags: "woman, sky, character, dreaming, instagram, twitter, facebook, twitch, youtube, linkedin, social, ideas, thinking",
  },
  {
    image: "marilyn_v73y.svg",
    title: "Marilyn",
    tags: "woman, character, white dress, dress, got me, 404 page",
  },
  {
    image: "staying_in_i80u.svg",
    title: "Staying in",
    tags: "bed, man, woman, characters, eat, pizza, home, bedroom",
  },
  {
    image: "organize_photos_d5nr.svg",
    title: "Organize photos",
    tags: "man, character, mobile, cell phone, photos, camera, collection",
  },
  {
    image: "podcast_q6p7.svg",
    title: "Podcast",
    tags: "woman, character, radio, netcast, digital audio, computer, laptop",
  },
  {
    image: "people_search_wctu.svg",
    title: "People search",
    tags: "man, woman, search, find, characters, contact.",
  },
  {
    image: "girl_just_wanna_have_fun_9d5u.svg",
    title: "Girls just wanna have fun",
    tags: "teen, teenagers, girls, woman, clothes, dress up, happy, characters",
  },
  {
    image: "messenger_e7iu.svg",
    title: "Messenger",
    tags: "mail, woman, send, character, receive, angel, wings, email",
  },
  {
    image: "social_networking_nqk4.svg",
    title: "Social networking",
    tags: "man, woman, office, work, chat, video chat, social media, online",
  },
  {
    image: "Ride_a_bicycle_2yok.svg",
    title: "Ride a bicycle",
    tags: "bike, boy, man, character, happy, hobby, bicycle",
  },
  {
    image: "friendship_mni7.svg",
    title: "Friendship",
    tags: "man, happy, characters, tree, friends, nature",
  },
  {
    image: "makeup_artist_rxn8.svg",
    title: "Makeup artist",
    tags: "beauty, cosmetics, people, man, woman, characters",
  },
  {
    image: "electric_car_b7hl.svg",
    title: "Electric car",
    tags: "elon musk, amrith, tesla, car, roadster, energy, roads",
  },
  {
    image: "freelancer_b0my.svg",
    title: "Freelancer",
    tags: "woman, working, home, character, laptop, apple, relax",
  },
  {
    image: "gaming_6oy3.svg",
    title: "Gaming",
    tags: "playstation, ps4, man, character, video games, sony, controller",
  },
  {
    image: "rising_8svm.svg",
    title: "Rising",
    tags: "tombstone, hand, cemetery, grave",
  },
  {
    image: "events_2p66.svg",
    title: "Events",
    tags: "calendar, woman, character, schedule, organize",
  },
  {
    image: "Follow_me_drone_kn76.svg",
    title: "Follow me drone",
    tags: "drone, ai, smart, woman, character, follow",
  },
  {
    image: "Bibliophile_hwqc.svg",
    title: "Bibliophile",
    tags: "books, read, love, woman, curious, character",
  },
  {
    image: "old_day_6x25.svg",
    title: "Old day",
    tags: "arcade, game, man, character",
  },
  {
    image: "co-working_825n.svg",
    title: "Co-working",
    tags: "together, man, woman, office, mac, report, documents, management, pc, mac",
  },
  {
    image: "segmentation_uioo.svg",
    title: "Segmentation",
    tags: "charts, tabs, metrics, numbers, excel, analytics, graphics, infographics, polls, analytics",
  },
  {
    image: "may_the_force_bgdm.svg",
    title: "May the force",
    tags: "star wars, movies, jedi",
  },
  {
    image: "back_in_the_day_knsh.svg",
    title: "Back in the day",
    tags: "old, pc, man, character",
  },
  {
    image: "goal_0v5v.svg",
    title: "Goal",
    tags: "ball, man, characters, activity, sport, fun, football, soccer",
  },
  {
    image: "firmware_mf69.svg",
    title: "Firmware",
    tags: "ai, artificial intelligence, robot, coding, man, characters, laptop",
  },
  {
    image: "country_side_ayop.svg",
    title: "Country side",
    tags: "woman, character, plats, nature, walk, relax",
  },
  {
    image: "blogging_vpvv.svg",
    title: "Blogging",
    tags: "woman, character, office, setup, website, online, laptop",
  },
  {
    image: "sunny_day_bk3m.svg",
    title: "Sunny day",
    tags: "woman, walk, relax, happy, sun, building",
  },
  {
    image: "sleep_analysis_o5f9.svg",
    title: "Sleep analysis",
    tags: "woman, analysis, data, bed, nap, cycle",
  },
  {
    image: "wishes_icyp.svg",
    title: "Wishes",
    tags: "lantern, woman, character, air",
  },
  {
    image: "data_report_bi6l.svg",
    title: "Data report",
    tags: "charts, tabs, metrics, numbers, excel, analytics, graphics, infographics, bars, polls, analytics",
  },
  {
    image: "healthy_habit_bh5w.svg",
    title: "Healthy habit",
    tags: "work out, apple, man, gym, health, diet, character",
  },
  {
    image: "static_assets_rpm6.svg",
    title: "Static assets",
    tags: "man, woman, server, characters, javascript, html, css",
  },
  {
    image: "in_love_3dcq.svg",
    title: "In love",
    tags: "man, woman, love, wait, together, happy, nature",
  },
  {
    image: "good_doggy_4wfq.svg",
    title: "Good doggy",
    tags: "dog, woman, pet, city, walk",
  },
  {
    image: "virtual_reality_y5ig.svg",
    title: "Virtual reality",
    tags: "vr, artificial intelligence, equipment, fantasy, gaming, equipment, projection, realistic, technology",
  },
  {
    image: "by_my_car_ttge.svg",
    title: "By my car",
    tags: "car, man, character, drive, relax",
  },
  {
    image: "filing_system_b5d2.svg",
    title: "Filing system",
    tags: "organize, documents, man, character, files, upload, take, download",
  },
  {
    image: "celebration_0jvk.svg",
    title: "Celebration",
    tags: "happy, people, man, woman, characters, success, achievement, welcome",
  },
  {
    image: "drone_race_0sim.svg",
    title: "Drone race",
    tags: "competition, race, sport, air racing",
  },
  {
    image: "artificial_intelligence_upfn.svg",
    title: "Artificial intelligence",
    tags: "ai, robot, machine, blocks",
  },
  {
    image: "mindfulness_scgo.svg",
    title: "Mindfulness",
    tags: "meditation, present moment, woman, character, buddhist, spa, yoga, workout, wellness, fitness",
  },
  {
    image: "make_it_rain_iwk4.svg",
    title: "Make it rain",
    tags: "credit card, money, man, character, payment",
  },
  {
    image: "building_blocks_n0nc.svg",
    title: "Building blocks",
    tags: "firewall, man, character, build, create, secure, improve, backyard, rocks, garden",
  },
  {
    image: "coding_6mjf.svg",
    title: "Coding",
    tags: "programmer, laptop, working, character, man, focus",
  },
  {
    image: "selfie_time_cws4.svg",
    title: "Selfie time",
    tags: "photo, woman, mobile, cell phone, character, iphone, self-portrait, smartphone",
  },
  {
    image: "web_devices_ad58.svg",
    title: "Web devices",
    tags: "internet, responsive, design, site, iphone, ipad, apple, imac, mac, woman, devices, real time",
  },
  {
    image: "eating_together_tjhx.svg",
    title: "Eating together",
    tags: "food, couple, noodles, dinner, lunch, meal, man, woman, characters",
  },
  {
    image: "drone_delivery_5vrm.svg",
    title: "Drone delivery",
    tags: "arrive, city, drone, packages",
  },
  {
    image: "street_food_hm5i.svg",
    title: "Street food",
    tags: "food, truck, man, woman, foodtruck, characters",
  },
  {
    image: "window_shopping_b96y.svg",
    title: "Window shopping",
    tags: "clothes, dresses, woman, pick, choose, design, thinking",
  },
  {
    image: "in_the_office_o44c.svg",
    title: "In the office",
    tags: "man, woman, working, together",
  },
  {
    image: "tasting_de22.svg",
    title: "Tasting",
    tags: "cupcake, food, sweet, man, eat",
  },
  {
    image: "romantic_getaway_k2mf.svg",
    title: "Romantic getaway",
    tags: "woman, man, tree, vacation, trip, relax, forest, love, together, couple",
  },
  {
    image: "image_upload_wqh3.svg",
    title: "Image upload",
    tags: "photo, man, site, personal, setup, browser, safari, upload, website",
  },
  {
    image: "newsletter_vovu.svg",
    title: "Newsletter",
    tags: "messages, email, inbox, envelope, opened, notification, received, outgoing, accepted",
  },
  {
    image: "easter_egg_hunt_r36d.svg",
    title: "Easter egg hunt",
    tags: "woman, bunny, eggs, happy, holiday, happy, hunting, easter, vacation",
  },
  {
    image: "finance_0bdk.svg",
    title: "Finance",
    tags: "laptop, man, money, economics, business, investment, banking, accounting, revenue, income, stock, funds",
  },
  {
    image: "through_the_desert_fcin.svg",
    title: "Through the desert",
    tags: "woman, desert, camel, pyramids, sun, travel, destination, trip",
  },
  {
    image: "grand_slam_0q5r.svg",
    title: "Grand slam",
    tags: "woman, tennis, sports, happy, racket, ball, elli",
  },
  {
    image: "walk_in_the_city_1ma6.svg",
    title: "Walk in the city",
    tags: "music, listening, city, plants, man, buildings, town, cool, headphones",
  },
  {
    image: "ethereum_fb7n.svg",
    title: "Ethereum",
    tags: "crypto, coin, cash, coinbase, blockchain, banks, money, women, plants",
  },
  {
    image: "website_setup_5hr2.svg",
    title: "Website setup",
    tags: "browser, woman, photo, site, personal website, easy",
  },
  {
    image: "co-workers_ujs6.svg",
    title: "Co-workers",
    tags: "together, man, woman, office, laptop, mac, report, documents, management",
  },
  {
    image: "departing_lsgy.svg",
    title: "Departing",
    tags: "travel, suitcase, airplane, destination, holidays, instagram, influencer, blogger",
  },
  {
    image: "mobile_apps_4wgf.svg",
    title: "Mobile apps",
    tags: "iphone, mobile, cell, apple, samsung, apps",
  },
  {
    image: "influencer_d3xx.svg",
    title: "Influencer",
    tags: "twitter, facebook, instagram, youtube, social, audience, girl, confident, modern woman, growth",
  },
  {
    image: "outer_space_3v6n.svg",
    title: "Outer space",
    tags: "astronaut, rocket, space, planets, launch, stars",
  },
  {
    image: "btc_p2p_lth5.svg",
    title: "Bitcoin P2P",
    tags: "crypto, coin, cash, coinbase, blockchain, satoshi, banks, money, women, plants",
  },
  {
    image: "social_strategy_1wuq.svg",
    title: "Social strategy",
    tags: "pinterest, twitter, facebook, instagram, trees, plants, woman",
  },
  {
    image: "together_j0gj.svg",
    title: "Together",
    tags: "man, woman, trees, couple, walk, nature",
  },
  {
    image: "modern_woman_9l0u.svg",
    title: "Modern woman",
    tags: "dog, animal, walk, city, street, landing, life, happy, plants, road",
  },
  {
    image: "meeting_115p.svg",
    title: "Meeting",
    tags: "bear, report, brainstorm, discussion, woman, startups, files, documents",
  },
  {
    image: "ordinary_day_xi0c.svg",
    title: "Ordinary day",
    tags: "houses, people, man, woman, trees, clouds, sun, birds, walking, street, life, happy",
  },
  {
    image: "home_run_oerh.svg",
    title: "Home run",
    tags: "baseball, sport, ball, hit, success, bat, man, win",
  },
  {
    image: "cloud_hosting_aodd.svg",
    title: "Cloud hosting",
    tags: "aws, amazon, google cloud, heroku, paas, hosting, platform, cloud, computing, apps",
  },
  {
    image: "broadcast_jhwx.svg",
    title: "Broadcast",
    tags: "wifi, antenna, internet",
  },
  {
    image: "tweetstorm_49e8.svg",
    title: "Tweetstorm",
    tags: "social media, twitter, box, bird",
  },
  {
    image: "happy_birthday_s72n.svg",
    title: "Happy birthday",
    tags: "balloons, gift, celebration, happy, festive",
  },
  {
    image: "JavaScript_Frameworks_x21l.svg",
    title: "JavaScript frameworks",
    tags: "react, vue, angular, jquery, plants, books, wall",
  },
  {
    image: "women_day_2m89.svg",
    title: "Women day",
    tags: "women, celebration, together, happy, love, sky",
  },
  {
    image: "spreadsheets_xdjy.svg",
    title: "Spreadsheets",
    tags: "documents, office, excel, math, organize, docs",
  },
  {
    image: "email_capture_x8kv.svg",
    title: "Email capture",
    tags: "gather, addresses, man, magnet, users, newsletter, gmail, yahoo",
  },
  {
    image: "fast_loading_0lbh.svg",
    title: "Fast loading",
    tags: "man, files, documents, speed, browser, light",
  },
  {
    image: "login_jdch.svg",
    title: "Login",
    tags: "man, door, sign in, entrance",
  },
  {
    image: "hello_aeia.svg",
    title: "Hello",
    tags: "man, character, laptop, mac, plant, office, happy, working, greeting, welcome, coffee",
  },
  {
    image: "collecting_fjjl.svg",
    title: "Collecting",
    tags: "documents, files, information, box, save, organize, data, research, keep, together",
  },
  {
    image: "organizing_projects1_47ja.svg",
    title: "Organizing projects",
    tags: "woman, pc, laptop, coffee, mac, plant, documents, files, arrange",
  },
  {
    image: "live_collaboration_2r4y.svg",
    title: "Live collaboration",
    tags: "people, man, woman, documents, excel, word, working, files, cloud, team, together, edit, add",
  },
  {
    image: "product_hunt_n3f5.svg",
    title: "Product hunt",
    tags: "woman, cat, cup, celebration",
  },
  {
    image: "connecting_teams3_1pgn.svg",
    title: "Connecting Teams",
    tags: "people, support, team, network, wheels, work, anywhere",
  },
  {
    image: "new_message_2gfk.svg",
    title: "New message",
    tags: "receive, messager, email, inbox, accepted",
  },
  {
    image: "Lighthouse_frb8.svg",
    title: "Lighthouse",
    tags: "sea, birds, clouds, welcome, login, sign in, sign up, landscape, trees",
  },
  {
    image: "houses3_xwf7.svg",
    title: "Houses",
    tags: "buildings, grow, real estate",
  },
  {
    image: "about_us_page_ee1k.svg",
    title: "About us page",
    tags: "members, profiles, people, search, results, club, voters, supporters, followers, woman, man, browser",
  },
  {
    image: "bitcoin2_ave7.svg",
    title: "Bitcoin",
    tags: "crypto, coin, cash, coinbase, blockchain, satoshi, banks, money",
  },
  {
    image: "fans_gr54.svg",
    title: "Fans",
    tags: "people, celebration, man, football, popcorn, soda, sofa, sport, win, lose",
  },
  {
    image: "Winter_olympics_p07j.svg",
    title: "Winter olympics",
    tags: "chloe kim, churros, winning, sport, snowboarder, snow, woman",
  },
  {
    image: "To_the_stars_qhyy.svg",
    title: "To the stars",
    tags: "rocket, fast, space, tesla, cloud, falcon heavy, elon musk, spacex, launch",
  },
  {
    image: "responsive_6c8s.svg",
    title: "Responsive",
    tags: "web design, office, pc, imac, design, plant, web application, desktop",
  },
  {
    image: "creation_process_vndn.svg",
    title: "Creation process",
    tags: "man, character, idea, brainstorming, notes, work, post-it, mvp",
  },
  {
    image: "designer_kcp7.svg",
    title: "Designer",
    tags: "working, office, man, character, plant, coffee",
  },
  {
    image: "profile_pic_ic5t.svg",
    title: "Profile pic",
    tags: "man, display image, personal, image, avatar, anges244",
  },
  {
    image: "team_ih79.svg",
    title: "Team",
    tags: "about us, members, profiles, people, search, results, club, voters, supporters, followers, woman, man",
  },
  {
    image: "notes1_cf55.svg",
    title: "Notes",
    tags: "woman, character, record, entry, item, memo",
  },
  {
    image: "selfie1_kpqf.svg",
    title: "Selfie",
    tags: "photo, iphone, samsung, mobile, cell, hand",
  },
  {
    image: "news_go0e.svg",
    title: "News",
    tags: "read, rss, report, announcement, story, broadcast, rumor, leak, statement, discovery, scandal, expos\u00e9, news flash, man",
  },
  {
    image: "development_ouy3.svg",
    title: "Development",
    tags: "creation, man, woman, people, progress, process",
  },
  {
    image: "messages1_9ah2.svg",
    title: "Messages",
    tags: "people, woman, cell, phone, mobile, social, group, iphone, samsung, communication, message, talk, sms, instant messaging, response, inbox, sent, chatbot, speak, language",
  },
  {
    image: "credit_card_payment_yb88.svg",
    title: "Credit card payment",
    tags: "credit card, money, banks, bitcoin, plastic, chip, buy, sell, payments, transactions, swipe, stripe, braintree",
  },
  {
    image: "love_is_in_the_air_4mmc.svg",
    title: "Love is in the air",
    tags: "couple, man, woman, in love, roses, happy, romantic, valentine",
  },
  {
    image: "superhero_kguv.svg",
    title: "Superhero",
    tags: "man, happy",
  },
  {
    image: "active_support_6rwo.svg",
    title: "Active support",
    tags: "man, online, social, chat, assistant, laptop",
  },
  {
    image: "design_process_iqqg.svg",
    title: "Design process",
    tags: "wireframing, mobile, cell, iphone, samsung",
  },
  {
    image: "control_panel1_20gm.svg",
    title: "Control panel",
    tags: "buttons, lever, switches, screwdriver",
  },
  {
    image: "transfer_files_6tns.svg",
    title: "Transfer files",
    tags: "share, upload, cloud, documents, sync",
  },
  {
    image: "hiring_cyhs.svg",
    title: "Hiring",
    tags: "work, cv, files, documents, reports, profiles, office, business, resume",
  },
  {
    image: "brainstorming_49d4.svg",
    title: "Brainstorming",
    tags: "students, ideas, woman, man, study, notes, working, together",
  },
  {
    image: "startman1_h7l9.svg",
    title: "Starman",
    tags: "elon musk, space, car",
  },
  {
    image: "post2_19cj.svg",
    title: "Post",
    tags: "opinions, community, feedback, site, feed, stream, rss, news, readlist, items",
  },
  {
    image: "graduation_9x4i.svg",
    title: "Graduation",
    tags: "college, education, learning, student, university",
  },
  {
    image: "no_data_qbuo.svg",
    title: "No data",
    tags: "empty state, not found",
  },
  {
    image: "cloud_sync_2aph.svg",
    title: "Cloud sync",
    tags: "server, mobile, cell, hand, check",
  },
  {
    image: "grades_j6jn.svg",
    title: "Grades",
    tags: "people, man, woman, level, charts, stats, rank, analytics",
  },
  {
    image: "gift1_sgf8.svg",
    title: "Gift",
    tags: "present, man, sitting, happy, achievement",
  },
  {
    image: "add_file2_gvbb.svg",
    title: "Add files",
    tags: "documents, upload, cloud, save",
  },
  {
    image: "connected_8wvi.svg",
    title: "Connected",
    tags: "people, man, woman, tablet, ipad, communicate, chat, check",
  },
  {
    image: "secure_data_0rwp.svg",
    title: "Secure data",
    tags: "lock, files, analytics, charts",
  },
  {
    image: "agreement_aajr.svg",
    title: "Agreement",
    tags: "handshake, partnership, contract, signing, people, business, deal",
  },
  {
    image: "taken_yju1.svg",
    title: "Taken",
    tags: "alien, ghost, 404, not found, spaceship",
  },
  {
    image: "confirmed_81ex.svg",
    title: "Confirmed",
    tags: "check, hand, mobile, cell, success, iphone, samsung",
  },
  {
    image: "security_on_6e8f.svg",
    title: "Security on",
    tags: "man, check, safe, shield, antivirus",
  },
  {
    image: "air_support_wy1q.svg",
    title: "Air support",
    tags: "help, people, woman, man, house, sky, sun, clouds",
  },
  {
    image: "beer_celebration_3wc8.svg",
    title: "Beer celebration",
    tags: "fun, drinking, happy, special moment, congrats",
  },
  {
    image: "chatting_2yvo.svg",
    title: "Chatting",
    tags: "people, woman, cell, phone, mobile, social, group, iphone, samsung",
  },
  {
    image: "upvote_96dp.svg",
    title: "Upvote",
    tags: "win, browser, chrome, safari, edge, mozilla",
  },
  {
    image: "secure_server_s9u8.svg",
    title: "Secure server",
    tags: "laptop, antivirus, computer, shield, virus",
  },
  {
    image: "queue_qt30.svg",
    title: "Queue",
    tags: "people, man, woman, waiting, in line",
  },
  {
    image: "choose_80qg.svg",
    title: "Choose",
    tags: "man, select, check",
  },
  {
    image: "chilling_8tii.svg",
    title: "Chilling",
    tags: "rest, man, cat, animal, relax, sofa",
  },
  {
    image: "swipe_profiles1_i6mr.svg",
    title: "Swipe profiles",
    tags: "man, woman, iphone, mobile, cell, browse, find",
  },
  {
    image: "real-time_sync_o57k.svg",
    title: "Real-time sync",
    tags: "laptop, mobile, iphone, mac, cell, devices, android, samsung, wifi, responsive, apple, ios, touch, mobile, cellphone, tablet, ipad",
  },
  {
    image: "add_user_ipe3.svg",
    title: "Add user",
    tags: "browser, man, safari, edge, mozilla",
  },
  {
    image: "customer_survey_f9ur.svg",
    title: "Customer survey",
    tags: "analysis, review, check",
  },
  {
    image: "mission_impossible_bwa2.svg",
    title: "Mission impossible",
    tags: "laptop, people, man",
  },
  {
    image: "filter_4kje.svg",
    title: "Filter",
    tags: "select, choose",
  },
  {
    image: "Cautious_dog_q83f.svg",
    title: "Cautious dog",
    tags: "hungry, food, pet, animal, cute, feed, smell",
  },
  {
    image: "Container_ship_urt4.svg",
    title: "Container ship",
    tags: "sea, sun, work, carrying, cargo, trade, transport",
  },
  {
    image: "playful_cat_ql3n.svg",
    title: "Playful cat",
    tags: "animal, fun, happy, purse",
  },
  {
    image: "specs2_2jb3.svg",
    title: "Specs",
    tags: "working, office, colors, mobile, iphone, diary, notes, ink, pen",
  },
  {
    image: "job_hunt_byf9.svg",
    title: "Job hunt",
    tags: "files, check, select, discovery, find, skills",
  },
  {
    image: "file_searching_duff.svg",
    title: "File searching",
    tags: "analytics, charts, organize, papers",
  },
  {
    image: "Jogging_t14q.svg",
    title: "Jogging",
    tags: "woman, health, running, workout, watch, apple, samsung",
  },
  {
    image: "collaboration2_8og0.svg",
    title: "Collaboration",
    tags: "file, man, woman, check, together, work",
  },
  {
    image: "working2_ce2b.svg",
    title: "Working",
    tags: "coffee, colors, mobile, iphone, notes, office",
  },
  {
    image: "experts3_3njd.svg",
    title: "Experts",
    tags: "man, woman, people, professional, experienced",
  },
  {
    image: "windows_q9m0.svg",
    title: "Windows",
    tags: "browsers, profile, websites, tabs",
  },
  {
    image: "destanation1_h3vq.svg",
    title: "Destination",
    tags: "travel, trip, woman, man, iphone, mobile, map",
  },
  {
    image: "Meditation_o89g.svg",
    title: "Meditation",
    tags: "workout, woman, gym, health, heart",
  },
  {
    image: "opened_gi4n.svg",
    title: "Opened",
    tags: "messages, email, inbox, envelope, success, opened, received, accepted",
  },
  {
    image: "growing_rk7d.svg",
    title: "Growing",
    tags: "charts, metrics, numbers, graphics, polls, analytics, statistics",
  },
  {
    image: "invite_i6u7.svg",
    title: "Invite",
    tags: "people, work, together, select, check, woman, man, profile",
  },
  {
    image: "pen_nqf7.svg",
    title: "Pen tool",
    tags: "tool, design, vector",
  },
  {
    image: "checklist_7q37.svg",
    title: "Checklist",
    tags: "to do, man, boy, arrange",
  },
  {
    image: "floating_61u6.svg",
    title: "Floating",
    tags: "man, woman, girl, boy, air, balloons, happy",
  },
  {
    image: "address_udes.svg",
    title: "Address",
    tags: "location, place, zip code, street",
  },
  {
    image: "vault_9cmw.svg",
    title: "Vault",
    tags: "money, bank, deposit, safe, lock, secure",
  },
  {
    image: "typing_jie3.svg",
    title: "Typing",
    tags: "communication, message, talk, sms, instant messaging, response, inbox, sent, chatbot, speak, language",
  },
  {
    image: "mail_box_kd5i.svg",
    title: "Mailbox",
    tags: "messages, email, inbox, envelope, success, opened, received, accepted",
  },
  {
    image: "house_searching_n8mp.svg",
    title: "House searching",
    tags: "tree, building, real estate",
  },
  {
    image: "sync4_xlc6.svg",
    title: "Sync",
    tags: "apple, watch, iphone, mobile, devices, android, samsung, phablet, cell, apple, ios, touch",
  },
  {
    image: "notebook_g9x9.svg",
    title: "Notebook",
    tags: "coffee, working, office, glasses, book",
  },
  {
    image: "alert_mc7b.svg",
    title: "Alert",
    tags: "security, pc, laptop, mobile, iphone, mac, safe",
  },
  {
    image: "movie_night_93wl.svg",
    title: "Movie night",
    tags: "drink, popcorn, watch, fun",
  },
  {
    image: "welcome_3gvl.svg",
    title: "Welcome",
    tags: "sign in, log in, happy, success, window, man, boy",
  },
  {
    image: "maintenance_cn7j.svg",
    title: "Maintenance",
    tags: "server, fast, cloud, database, upkeep, care, repair",
  },
  {
    image: "setup_obqo.svg",
    title: "Setup",
    tags: "system, structure, organization, arrangement, framework, format, layout, composition",
  },
  {
    image: "select_13cv.svg",
    title: "Select",
    tags: "iphone, devices, android, samsung, phablet, cell, apple, ios, touch",
  },
  {
    image: "presentation1_tqkp.svg",
    title: "Presentation",
    tags: "demonstration, talk, lecture, address, speech, show, exhibition, display, introduction, launch",
  },
  {
    image: "photo_sharing_1_85vy.svg",
    title: "Photo sharing",
    tags: "polaroid, moment, picture, mountain, landscape, media, files, png, svg, jpeg, jpg, capture, photography, twitter, facebook, google plus, pinterest, linkedin, chrome, safari, edge, mozilla",
  },
  {
    image: "mail_2_tqip.svg",
    title: "Mail",
    tags: "messages, email, inbox, envelope, success, opened, notification, received, outgoing, accepted, iphone",
  },
  {
    image: "camping_j8s0.svg",
    title: "Camping",
    tags: "bear, woods, happy, tree, fire, trip, vacation",
  },
  {
    image: "safe_bnk7.svg",
    title: "Safe",
    tags: "security, browser, lock, chrome, safari, edge, mozilla, private",
  },
  {
    image: "account_490v.svg",
    title: "Account",
    tags: "profile, report, record",
  },
  {
    image: "processing_qj6a.svg",
    title: "Processing",
    tags: "method, pc, apple, mac, woman, working, office, systematic actions, convert",
  },
  {
    image: "for_sale_viax.svg",
    title: "For sale",
    tags: "house, tree, sun, building, real estate",
  },
  {
    image: "data_xmfy.svg",
    title: "Data",
    tags: "charts, tabs, metrics, numbers, excel, analytics, graphics, infographics, pie, bars, segmentation, polls, analytics, statistics",
  },
  {
    image: "Golden_Gate_Bridge_00us.svg",
    title: "Golden gate bridge",
    tags: "sun, boat, ship, sea, river, sailing",
  },
  {
    image: "calendar_dutt.svg",
    title: "Calendar",
    tags: "hour, appointment, meeting, month, day, clock",
  },
  {
    image: "social_growth_d0y3.svg",
    title: "Social growth",
    tags: "twitter, facebook, google plus, pinterest, linkedin, chrome, safari, edge, mozilla",
  },
  {
    image: "search_engines_nn9e.svg",
    title: "Search engines",
    tags: "results, google, bing, yahoo, yandex, filter, find, discover, results, ranking, seo, discover",
  },
  {
    image: "server_q2pb.svg",
    title: "Server",
    tags: "pc, download, upload, fast, cloud, database",
  },
  {
    image: "bus_stop_h370.svg",
    title: "Bus stop",
    tags: "dog, people, trees, happy, woman, girl, boy, man, road, waiting",
  },
  {
    image: "relaxation_1_wbr7.svg",
    title: "Relaxation",
    tags: "sun, beach, happy, leisure, enjoyment",
  },
  {
    image: "segment_uwu1.svg",
    title: "Segment",
    tags: "section, part, pc, mac, apple, browser, man",
  },
  {
    image: "contrast_vb82.svg",
    title: "Contrast",
    tags: "browser, light, dark, difference, color, compare",
  },
  {
    image: "browser_stats_704t.svg",
    title: "Browser stats",
    tags: "charts, tabs, metrics, numbers, excel, analytics, graphics, infographics, pie, bars, segmentation, polls, analytics, chrome, safari, edge, mozilla",
  },
  {
    image: "appreciation_2_v4bt.svg",
    title: "Appreciation",
    tags: "engage, collect, love, heart, click, gain, show, target",
  },
  {
    image: "couple_a7s9.svg",
    title: "Couple",
    tags: "man, woman, romantic, girlfriend, boyfriend, love, together, happy",
  },
  {
    image: "create_f05x.svg",
    title: "Create",
    tags: "combine, feedback",
  },
  {
    image: "morning_essentials_9fw8.svg",
    title: "Morning essentials",
    tags: "alarm, clock, coffee, mondays, wake up, warm, iphone, devices, android, samsung, cell, wireless, wifi, apple, ios, touch",
  },
  {
    image: "resume_folder_2_arse.svg",
    title: "Resume folder",
    tags: "work, cv, files, documents, reports, profiles, hiring, hire, office, business",
  },
  {
    image: "images_aef7.svg",
    title: "Images",
    tags: "picture, mountain, landscape, memories, media, svg, png, jpeg, jpg, gif, files, photography, photos",
  },
  {
    image: "Astronaut_0o7w.svg",
    title: "Astronaut",
    tags: "space, flag, success, happy, achieve, stars",
  },
  {
    image: "depi_wexf.svg",
    title: "Depi",
    tags: "woman, bikini, beach, tanning, swimsuit, swimwear, styling, fashion, young, bathing suit",
  },
  {
    image: "Building_leu4.svg",
    title: "Building",
    tags: "architecture, construction, home, house, sun, engineering, modeling, habitation",
  },
  {
    image: "statistics_ctoq.svg",
    title: "Statistics",
    tags: "charts, tabs, metrics, numbers, excel, analytics, graphics, infographics, pie, bars, segmentation, polls, analytics",
  },
  {
    image: "passing_by_gqfk.svg",
    title: "Passing by",
    tags: "dog, cute, happy, peeing, stop",
  },
  {
    image: "Internet_on_the_go_5xx0.svg",
    title: "Internet on the go",
    tags: "iphone, devices, android, samsung, phablet, cell, wireless, wifi, responsive, apple, ios, touch, mobile, cellphone, tablet, ipad",
  },
  {
    image: "resume_1hqp.svg",
    title: "Resume",
    tags: "work, cv, files, documents, reports, profiles, hiring, hire, office, business",
  },
  {
    image: "snowman_1_a2ch.svg",
    title: "Snowman",
    tags: "christmas, holiday, freeze, cold, winter, new year, frosty, happy",
  },
  {
    image: "autumn_2_ygk5.svg",
    title: "Autumn",
    tags: "fall, couple, woman, man, umbrella, bench, leaves, together, walk, life, love, romantic",
  },
  {
    image: "social_tree_1_y9wa.svg",
    title: "Social tree",
    tags: "christmas, twitter, facebook, google plus, pinterest, linkedin, holiday, xmas, new year, gifts",
  },
  {
    image: "working_woman_3uve.svg",
    title: "Designer girl",
    tags: "woman, pc, sitting, office, drawing, illustrator, sketch, photoshop, canvas, create, web design, modern",
  },
  {
    image: "man_eiev.svg",
    title: "Nerd",
    tags: "man, glasses, happy, godin, tech, hipster, people, human, customer support",
  },
  {
    image: "woman_mevk.svg",
    title: "Woman",
    tags: "call, happy, girl, mobile, dog, walk, happy, cell phone, dog sitting, trendy, hoodie",
  },
  {
    image: "map_light_6ttm.svg",
    title: "Map light",
    tags: "destination, road, location, directions, pin, gps, guide, landmark, address, where, travel",
  },
  {
    image: "photos_1nui.svg",
    title: "Photos",
    tags: "polaroid, moment, picture, mountain, landscape, media, files, png, svg, jpeg, jpg, capture, photography",
  },
  {
    image: "Posts_rskc.svg",
    title: "Posts",
    tags: "opinions, community, feedback, site, feed, stream, rss, news, readlist, items",
  },
  {
    image: "mobile_prle.svg",
    title: "Mobile",
    tags: "iphone, devices, android, samsung, phablet, cell, wireless, wifi, responsive, apple, ios, touch",
  },
  {
    image: "folder_x4ft.svg",
    title: "Image folder",
    tags: "organize, photos, images, media, files, container, store",
  },
  {
    image: "tabs_jf82.svg",
    title: "Tabs",
    tags: "browsers, profile, websites, portfolio, pages, social, images, twitter",
  },
  {
    image: "travel_pb6m.svg",
    title: "Yacht",
    tags: "ship, boat, sea, sun, destination, cruise, travel, caribbean, luxury, money, billionaire, atlantic, sunbathe, holidays, summer",
  },
  {
    image: "plain_credit_card_c8b8.svg",
    title: "Plain credit card",
    tags: "credit card, money, banks, bitcoin, plastic, chip, buy, sell, payments, transactions, swipe, stripe, braintree",
  },
  {
    image: "portfolio_essv.svg",
    title: "Portfolio",
    tags: "personal, site, work, photos, gallery, images, page load, pages, websites, designer",
  },
  {
    image: "analytics_5pgy.svg",
    title: "Analytics",
    tags: "charts, tabs, metrics, numbers, excel, analytics, statistics, graphics, infographics, pie, bars, segmentation, polls",
  },
  {
    image: "files1_9ool.svg",
    title: "Documents",
    tags: "organize, work, read, files, media, reports, papers, analysis, stack, dropbox, copy, clone",
  },
  {
    image: "chat_1wo5.svg",
    title: "Chat",
    tags: "communication, message, talk, sms, instant messaging, response, inbox, sent, chatbot, speak, language",
  },
  {
    image: "mail1_uab6.svg",
    title: "Delivery",
    tags: "travel, gps, location, road, mobile, iphone, landmark, invitation, invite, destination, locate",
  },
  {
    image: "files_6b3d.svg",
    title: "At work",
    tags: "coffee, work, cv, resume, files, documents, reports, profiles, hiring, hire, office, business",
  },
  {
    image: "Devices_e67q.svg",
    title: "Devices",
    tags: "pc, laptop, mobile, iphone, mac, tablet, ipad, screens, android, phablet, desktop, imac, apple, windows, responsive, web",
  },
  {
    image: "charts_jj6t.svg",
    title: "Charts",
    tags: "analytics, metrics, numbers, excel, statistics, graphics, infographics, pie, bars, segmentation, polls",
  },
  {
    image: "blog_anyj.svg",
    title: "Blog post",
    tags: "report, write, site, presentation, read, document, articles, posts, letter, learn",
  },
  {
    image: "photo_4yb9.svg",
    title: "Photo",
    tags: "picture, mountain, landscape, memories, media, svg, png, jpeg, jpg, gif, files, images, photography",
  },
  {
    image: "map_dros.svg",
    title: "Map dark",
    tags: "destination, road, location, directions, pin, gps, guide, landmark, address, where",
  },
  {
    image: "search_2dfv.svg",
    title: "Search",
    tags: "results, google, bing, yahoo, yandex, filter, find, discover, results, ranking, seo, discover",
  },
  {
    image: "mail_cg1t.svg",
    title: "Mail sent",
    tags: "messages, email, inbox, envelope, success, opened, notification, received, outgoing, accepted",
  },
  {
    image: "pcsocial_16rw.svg",
    title: "Social media",
    tags: "pc, facebook, twitter, google, pinterest, likedin, community, work, office, coffee, at work, marketing, marketer, outreach, viral",
  },
  {
    image: "credit_card_df1m.svg",
    title: "Credit card",
    tags: "credit card, money, banks, bitcoin, plastic, chip, buy, sell, payments, transactions, swipe, stripe, braintree",
  },
];

export default fileNames;
